import styled from '@emotion/styled'
import {
  WORKFLOW_CONDITION_IS_TODAY,
  WORKFLOW_CONDITION_MINUS_X_DAYS_IS_TODAY,
  //
  WORKFLOW_CONDITION_PLUS_X_DAYS_IS_TODAY,
  //
  WORKFLOW_FIELD_TYPE_DATETIME
} from 'Constants/'
import {
  Flex,
  FlexItem,
  FormElement,
  INPUT_TEXT_VARIANT_DANGER,
  InputNumber,
  RadioButton
} from 'mailup-web-components'
import { step2State } from 'Pages/Workflow/recoil/state/step2'
import { useState } from 'react'

import { useIntl } from 'react-intl'

import { useRecoilValue, useSetRecoilState } from 'recoil'

const StyledInlineLabel = styled.label`
  font-weight: 400;
  cursor: pointer;
`

const InputIdFieldFilterDate = () => {
  const intl = useIntl()

  const { IdFieldFilter, FieldType, FieldValue } = useRecoilValue(step2State)
  const setWorkflowDetailsState = useSetRecoilState(step2State)

  const [daysBefore, setDaysBefore] = useState(
    FieldType !== WORKFLOW_FIELD_TYPE_DATETIME &&
      IdFieldFilter === WORKFLOW_CONDITION_MINUS_X_DAYS_IS_TODAY
      ? parseInt(FieldValue)
      : 1
  )

  const [daysAfter, setDaysAfter] = useState(
    FieldType !== WORKFLOW_FIELD_TYPE_DATETIME &&
      IdFieldFilter === WORKFLOW_CONDITION_PLUS_X_DAYS_IS_TODAY
      ? parseInt(FieldValue)
      : 1
  )

  const handleDaysBeforeChange = (value) => {
    setDaysBefore(value)
    setWorkflowDetailsState((prev) => ({ ...prev, FieldValue: `${value}` }))
  }

  const handleDaysAfterChange = (value) => {
    setDaysAfter(value)
    setWorkflowDetailsState((prev) => ({ ...prev, FieldValue: `${value}` }))
  }

  const handleConditionTodayChange = ({ target: { checked } }) => {
    setWorkflowDetailsState((prev) => ({
      ...prev,
      IdFieldFilter: WORKFLOW_CONDITION_IS_TODAY,
      FieldValue: ''
    }))
    setDaysBefore(1)
    setDaysAfter(1)
  }

  const handleConditionDaysBeforeChange = ({ target: { checked } }) => {
    setWorkflowDetailsState((prev) => ({
      ...prev,
      IdFieldFilter: WORKFLOW_CONDITION_MINUS_X_DAYS_IS_TODAY,
      FieldValue: `${daysBefore}`
    }))
    // setDaysBefore(1)
  }

  const handleConditionDaysAfterChange = ({ target: { checked } }) => {
    setWorkflowDetailsState((prev) => ({
      ...prev,
      IdFieldFilter: WORKFLOW_CONDITION_PLUS_X_DAYS_IS_TODAY,
      FieldValue: `${daysAfter}`
    }))
    //  setDaysAfter(1)
  }

  const daysBeforeIsValid =
    daysBefore !== null && daysBefore >= 0 && daysBefore <= 999

  const daysAfterIsValid =
    daysAfter !== null && daysAfter >= 0 && daysAfter <= 999

  const wrongFormatFeedback = intl.formatMessage(
    {
      id: 'Load.AutomationWorkflow.LastDayValidation'
    },
    {
      XGIORNI: 999
    }
  )

  return (
    <FormElement
      label={intl.formatMessage({
        id: 'Load.AutomationWorkflow.EventTimeTile'
      })}
      required
    >
      <Flex flexDirection='column' rowGap='16px' margin='24px 0'>
        <FlexItem>
          <Flex alignItems='flex-start' justifyContent='flex-start'>
            <RadioButton
              id='eventConditionToday'
              value={WORKFLOW_CONDITION_IS_TODAY}
              checked={IdFieldFilter === WORKFLOW_CONDITION_IS_TODAY}
              onChange={handleConditionTodayChange}
            />
            <StyledInlineLabel htmlFor='eventConditionToday'>
              {intl.formatMessage({
                id: 'Load.AutomationWorkflow.EventTimeToday'
              })}
            </StyledInlineLabel>
          </Flex>
        </FlexItem>
        <FlexItem>
          <Flex alignItems='flex-start'>
            <FlexItem margin='8px 0 0 0'>
              <RadioButton
                id='eventConditionBefore'
                value={WORKFLOW_CONDITION_MINUS_X_DAYS_IS_TODAY}
                checked={
                  IdFieldFilter === WORKFLOW_CONDITION_MINUS_X_DAYS_IS_TODAY
                }
                onChange={handleConditionDaysBeforeChange}
              />
            </FlexItem>
            <FormElement
              feedback={!daysBeforeIsValid ? wrongFormatFeedback : undefined}
              feedbackVariant={!daysBeforeIsValid ? 'danger' : undefined}
            >
              <Flex alignItems='flex-start'>
                <Flex
                  display='block'
                  width='75px'
                  flexGrow='0'
                  margin='0 16px 0 0'
                >
                  <InputNumber
                    value={daysBefore}
                    onChange={handleDaysBeforeChange}
                    disabled={
                      IdFieldFilter !== WORKFLOW_CONDITION_MINUS_X_DAYS_IS_TODAY
                    }
                    min={0}
                    max={999}
                    step={1}
                    maxLength={3}
                    variant={
                      !daysBeforeIsValid ? INPUT_TEXT_VARIANT_DANGER : undefined
                    }
                  />
                </Flex>
                <FlexItem margin='8px 0 0 0'>
                  <StyledInlineLabel htmlFor='eventConditionBefore'>
                    {intl.formatMessage({
                      id: 'Load.AutomationWorkflow.EventTimeDayBefore'
                    })}
                  </StyledInlineLabel>
                </FlexItem>
              </Flex>
            </FormElement>
          </Flex>
        </FlexItem>
        <FlexItem>
          <Flex alignItems='flex-start' justifyContent='flex-start'>
            <FlexItem margin='8px 0 0 0'>
              <RadioButton
                id='eventConditionAfter'
                value={WORKFLOW_CONDITION_PLUS_X_DAYS_IS_TODAY}
                checked={
                  IdFieldFilter === WORKFLOW_CONDITION_PLUS_X_DAYS_IS_TODAY
                }
                onChange={handleConditionDaysAfterChange}
              />
            </FlexItem>
            <FormElement
              feedback={!daysAfterIsValid ? wrongFormatFeedback : undefined}
              feedbackVariant={!daysAfterIsValid ? 'danger' : undefined}
            >
              <Flex alignItems='flex-start'>
                <Flex display='block' width='75px' margin='0 16px 0 0'>
                  <InputNumber
                    value={daysAfter}
                    onChange={handleDaysAfterChange}
                    disabled={
                      IdFieldFilter !== WORKFLOW_CONDITION_PLUS_X_DAYS_IS_TODAY
                    }
                    min={0}
                    max={999}
                    step={1}
                    maxLength={3}
                    variant={
                      !daysAfterIsValid ? INPUT_TEXT_VARIANT_DANGER : undefined
                    }
                  />
                </Flex>
                <FlexItem margin='8px 0 0 0'>
                  <StyledInlineLabel htmlFor='eventConditionAfter'>
                    {intl.formatMessage({
                      id: 'Load.AutomationWorkflow.EventTimeDayAfter'
                    })}
                  </StyledInlineLabel>
                </FlexItem>
              </Flex>
            </FormElement>
          </Flex>
        </FlexItem>
      </Flex>
    </FormElement>
  )
}

export default InputIdFieldFilterDate
